/**
 * =============================================================================
 * slot-machine-popup.js
 * Premium Slot Machine Popup — Coming Soon Launch Campaign
 *
 * Services:
 *   Brevo API — sends OTP verification email + coupon delivery email
 *   Klaviyo   — saves verified email to launch marketing list
 *   Shopify   — saves customer via hidden {% form 'customer' %}
 *
 * Keys:
 *   Brevo API Key:       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
 *   Klaviyo Public Key:  XvwPfe
 *   Klaviyo List ID:     VkUUdz
 * =============================================================================
 */

(function () {
  'use strict';

  /* ============================================================
     1. CONFIGURATION
     ============================================================ */

  var CONFIG = {
    openDelay: 5000,

    symbols: ['🍌', '🍒', '🍓'],

    prizes: [
      { id: 'jackpot', discount: 20, coupon: 'LAUNCH20', probability: 30 },
      { id: 'second',  discount: 10, coupon: 'LAUNCH10', probability: 40 },
      { id: 'third',   discount:  5, coupon: 'LAUNCH5',  probability: 30 }
    ],

    combinations: {
      jackpot: [[0,0,0],[1,1,1],[2,2,2]],
      second:  [[0,0,2],[1,1,0],[2,2,1]],
      third:   [[0,1,2]]
    },

    reel: {
      visibleRows: 7,
      extraSpins:  4,
      durationMs:  900,
      staggerMs:   250,
      easing:      'cubic-bezier(0.23, 1, 0.32, 1)'
    },

    /* Brevo API — sends both OTP and coupon emails */
    brevo: {
      apiKey:      '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',
      fromEmail:   'cooq.performance@gmail.com',
      fromName:    'COOQ'
    },

    /* Klaviyo */
    klaviyo: {
      publicKey: 'XvwPfe',
      listId:    'VkUUdz'
    },

    otp: {
      length:      6,
      expiryMs:    15 * 60 * 1000,
      resendDelay: 30
    },

    storage: {
      played:   'sm_played',
      coupon:   'sm_coupon',
      discount: 'sm_discount',
      email:    'sm_email'
    },

    confettiCount: 160
  };


  /* ============================================================
     2. STATE
     ============================================================ */

  var STATE = {
    isSpinning:        false,
    hasSpun:           false,
    currentPrize:      null,
    currentCombo:      null,
    currentEmail:      '',
    currentOtp:        '',
    otpExpiry:         null,
    resendTimer:       null,
    confettiAnim:      null,
    confettiParticles: []
  };


  /* ============================================================
     3. DOM REFERENCES
     ============================================================ */

  var DOM = {};

  function cacheDom() {
    DOM.overlay             = document.getElementById('sm-overlay');
    DOM.popup               = document.getElementById('sm-popup');
    DOM.closeBtn            = document.getElementById('sm-close-btn');
    DOM.confettiCanvas      = document.getElementById('sm-confetti-canvas');

    DOM.screenSpin          = document.getElementById('sm-screen-spin');
    DOM.screenEmail         = document.getElementById('sm-screen-email');
    DOM.screenOtp           = document.getElementById('sm-screen-otp');
    DOM.screenSuccess       = document.getElementById('sm-screen-success');
    DOM.screenReturning     = document.getElementById('sm-screen-returning');

    DOM.reel1               = document.getElementById('sm-reel-1');
    DOM.reel2               = document.getElementById('sm-reel-2');
    DOM.reel3               = document.getElementById('sm-reel-3');
    DOM.spinBtn             = document.getElementById('sm-spin-btn');

    DOM.winDiscount         = document.getElementById('sm-win-discount');
    DOM.customerForm        = document.getElementById('sm-customer-form');
    DOM.emailInput          = document.getElementById('sm-email-input');
    DOM.claimBtn            = document.getElementById('sm-claim-btn');
    DOM.skipBtn             = document.getElementById('sm-skip-btn');

    DOM.otpEmailDisplay     = document.getElementById('sm-otp-email-display');
    DOM.otpInputs           = document.querySelectorAll('.sm-otp-input');
    DOM.otpInputsWrapper    = document.querySelector('.sm-otp-inputs');
    DOM.otpError            = document.getElementById('sm-otp-error');
    DOM.verifyBtn           = document.getElementById('sm-verify-btn');
    DOM.resendTimerEl       = document.getElementById('sm-resend-timer');
    DOM.resendCountdown     = document.getElementById('sm-resend-countdown');
    DOM.resendBtn           = document.getElementById('sm-resend-btn');
    DOM.otpBackBtn          = document.getElementById('sm-otp-back-btn');

    DOM.successEmailDisplay = document.getElementById('sm-success-email-display');
    DOM.successDiscount     = document.getElementById('sm-success-discount');
    DOM.successDismissBtn   = document.getElementById('sm-success-dismiss-btn');

    DOM.returningSubheading   = document.getElementById('sm-returning-subheading');
    DOM.returningEmailDisplay = document.getElementById('sm-returning-email-display');
    DOM.returningDismissBtn   = document.getElementById('sm-returning-dismiss-btn');

    DOM.hiddenForm  = document.getElementById('sm-hidden-shopify-form');
    DOM.hiddenEmail = document.getElementById('sm-hidden-email');
    DOM.hiddenTags  = document.getElementById('sm-hidden-tags');
    DOM.hiddenNote  = document.getElementById('sm-hidden-note');

    DOM.reelWrappers = [
      DOM.reel1.closest('.sm-reel-wrapper'),
      DOM.reel2.closest('.sm-reel-wrapper'),
      DOM.reel3.closest('.sm-reel-wrapper')
    ];
  }


  /* ============================================================
     4. INITIALISATION
     ============================================================ */

  function init() {
    if (!document.getElementById('sm-overlay')) return;
    cacheDom();
    buildReels();
    bindEvents();

    if (hasAlreadyPlayed()) {
      scheduleOpen(0);
    } else {
      scheduleOpen(CONFIG.openDelay);
    }
  }

  function scheduleOpen(delayMs) {
    setTimeout(function () {
      showOverlay();
      if (hasAlreadyPlayed()) {
        populateReturningScreen();
        showScreen(DOM.screenReturning);
      } else {
        showScreen(DOM.screenSpin);
      }
    }, delayMs);
  }


  /* ============================================================
     5. LOCALSTORAGE HELPERS
     ============================================================ */

  function hasAlreadyPlayed() {
    try { return localStorage.getItem(CONFIG.storage.played) === 'true'; }
    catch (e) { return false; }
  }

  function savePlayResult(coupon, discount, email) {
    try {
      localStorage.setItem(CONFIG.storage.played,   'true');
      localStorage.setItem(CONFIG.storage.coupon,   coupon);
      localStorage.setItem(CONFIG.storage.discount, String(discount));
      localStorage.setItem(CONFIG.storage.email,    email || '');
    } catch (e) { /* degrade gracefully */ }
  }

  function getSavedEmail()    {
    try { return localStorage.getItem(CONFIG.storage.email)    || ''; } catch (e) { return ''; }
  }
  function getSavedDiscount() {
    try { return localStorage.getItem(CONFIG.storage.discount) || ''; } catch (e) { return ''; }
  }


  /* ============================================================
     6. OVERLAY / POPUP SHOW & HIDE
     ============================================================ */

  function showOverlay() {
    DOM.overlay.removeAttribute('aria-hidden');
    DOM.overlay.classList.add('sm-overlay--visible');
    DOM.overlay.classList.remove('sm-overlay--hidden');
    DOM.closeBtn.focus();
  }

  function hideOverlay() {
    DOM.overlay.classList.remove('sm-overlay--visible');
    DOM.overlay.classList.add('sm-overlay--hidden');
    DOM.overlay.setAttribute('aria-hidden', 'true');
    stopConfetti();
    clearResendTimer();
  }

  function showScreen(screenEl) {
    var all = [
      DOM.screenSpin, DOM.screenEmail, DOM.screenOtp,
      DOM.screenSuccess, DOM.screenReturning
    ];
    all.forEach(function (el) {
      if (!el) return;
      el === screenEl
        ? el.classList.remove('sm-screen--hidden')
        : el.classList.add('sm-screen--hidden');
    });
  }


  /* ============================================================
     7. REEL BUILDER
     ============================================================ */

  function buildReels() {
    [DOM.reel1, DOM.reel2, DOM.reel3].forEach(function (reelEl) {
      reelEl.innerHTML = '';
      var totalRows = CONFIG.reel.visibleRows
                    + CONFIG.reel.extraSpins * CONFIG.symbols.length + 3;
      for (var i = 0; i < totalRows; i++) {
        var span = document.createElement('span');
        span.className   = 'sm-reel__symbol';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = CONFIG.symbols[i % CONFIG.symbols.length];
        reelEl.appendChild(span);
      }
      reelEl.style.transform  = 'translateY(0)';
      reelEl.style.transition = 'none';
    });
  }


  /* ============================================================
     8. PRIZE ENGINE
     ============================================================ */

  function pickPrize() {
    var roll = randomInt(1, 100), cumulative = 0;
    for (var i = 0; i < CONFIG.prizes.length; i++) {
      cumulative += CONFIG.prizes[i].probability;
      if (roll <= cumulative) return CONFIG.prizes[i];
    }
    return CONFIG.prizes[CONFIG.prizes.length - 1];
  }

  function pickCombination(prize) {
    var opts = CONFIG.combinations[prize.id];
    return opts[randomInt(0, opts.length - 1)];
  }


  /* ============================================================
     9. SPIN ORCHESTRATOR
     ============================================================ */

  function startSpin() {
    if (STATE.isSpinning || STATE.hasSpun) return;
    STATE.isSpinning = true;

    DOM.spinBtn.disabled = true;
    DOM.spinBtn.querySelector('.sm-btn__label').textContent = 'Spinning\u2026';
    DOM.spinBtn.classList.add('is-spinning');
    DOM.reelWrappers.forEach(function (w) { w.classList.remove('sm-reel-wrapper--winner'); });

    STATE.currentPrize = pickPrize();
    STATE.currentCombo = pickCombination(STATE.currentPrize);

    Promise.all([DOM.reel1, DOM.reel2, DOM.reel3].map(function (el, idx) {
      return animateReel(el, STATE.currentCombo[idx], idx);
    })).then(onSpinComplete);
  }

  function onSpinComplete() {
    STATE.isSpinning = false;
    STATE.hasSpun    = true;
    DOM.reelWrappers.forEach(function (w) { w.classList.add('sm-reel-wrapper--winner'); });
    launchConfetti();
    setTimeout(showEmailScreen, 1400);
  }


  /* ============================================================
     10. REEL ANIMATION
     ============================================================ */

  function animateReel(reelEl, targetSymbol, reelIndex) {
    return new Promise(function (resolve) {
      var symbolHeight = reelEl.closest('.sm-reel-wrapper').offsetHeight;
      var extraRows    = CONFIG.reel.extraSpins * CONFIG.symbols.length;
      var targetY      = -((extraRows + targetSymbol) * symbolHeight);
      var delay        = reelIndex * CONFIG.reel.staggerMs;
      var duration     = CONFIG.reel.durationMs + reelIndex * CONFIG.reel.staggerMs;

      reelEl.style.transition = 'none';
      reelEl.style.transform  = 'translateY(0)';
      void reelEl.offsetHeight;

      setTimeout(function () {
        reelEl.style.transition = 'transform ' + duration + 'ms ' + CONFIG.reel.easing;
        reelEl.style.transform  = 'translateY(' + targetY + 'px)';
        setTimeout(resolve, duration);
      }, delay);
    });
  }


  /* ============================================================
     11. EMAIL SCREEN
     ============================================================ */

  function showEmailScreen() {
    DOM.winDiscount.textContent = STATE.currentPrize.discount + '% OFF';
    showScreen(DOM.screenEmail);
    DOM.emailInput.focus();
  }

  function handleFormSubmit(e) {
    e.preventDefault();

    var email = DOM.emailInput.value.trim();
    if (!email || !isValidEmail(email)) {
      showInputError(DOM.emailInput, 'Please enter a valid email address.');
      DOM.emailInput.focus();
      return;
    }
    clearInputError(DOM.emailInput);

    STATE.currentEmail = email;

    DOM.claimBtn.disabled = true;
    DOM.claimBtn.querySelector('.sm-btn__label').textContent = 'Sending code\u2026';

    sendOtpViaBrevo(email).then(function () {
      DOM.claimBtn.disabled = false;
      DOM.claimBtn.querySelector('.sm-btn__label').textContent = 'Send Verification Code';
      showOtpScreen(email);
    }).catch(function (err) {
      console.error('OTP send failed:', err);
      DOM.claimBtn.disabled = false;
      DOM.claimBtn.querySelector('.sm-btn__label').textContent = 'Send Verification Code';
      /* Show OTP screen anyway — degrade gracefully */
      showOtpScreen(email);
    });
  }

  function handleSkip() {
    savePlayResult(STATE.currentPrize.coupon, STATE.currentPrize.discount, '');
    showSuccessScreen('');
  }


  /* ============================================================
     12. BREVO EMAIL SENDING
     Sends emails directly via Brevo Transactional Email API v3.
     No EmailJS needed — direct API call from browser.
     300 free emails per day. Excellent inbox delivery.
     ============================================================ */

  /**
   * Send OTP verification email via Brevo API
   */
  function sendOtpViaBrevo(email) {
    STATE.currentOtp  = generateOtp();
    STATE.otpExpiry   = Date.now() + CONFIG.otp.expiryMs;

    var expiryDate  = new Date(STATE.otpExpiry);
    var expiryHours = expiryDate.getHours();
    var expiryMins  = expiryDate.getMinutes().toString().padStart(2, '0');
    var ampm        = expiryHours >= 12 ? 'PM' : 'AM';
    expiryHours     = expiryHours % 12 || 12;
    var expiryTime  = expiryHours + ':' + expiryMins + ' ' + ampm;

    var htmlContent = '<!DOCTYPE html><html><body>'
      + '<div style="font-family:system-ui,sans-serif;font-size:14px;max-width:480px;margin:0 auto;">'
      + '<div style="text-align:center;padding:32px 24px 24px;">'
      + '<img style="height:48px;width:auto;" src="https://cdn.shopify.com/s/files/1/0653/5446/5487/files/cooq_logo_200x60@2x.png?v=1779358221" alt="COOQ"/>'
      + '</div>'
      + '<div style="border-top:1px solid #eaeaea;padding:24px;">'
      + '<p style="color:#333;">Hi there,</p>'
      + '<p style="color:#333;">To claim your launch discount from COOQ, please verify your email using the code below:</p>'
      + '<div style="background:#f9f9f9;border:1px solid #eaeaea;border-radius:12px;padding:24px;text-align:center;margin:24px 0;">'
      + '<p style="margin:0 0 8px;font-size:12px;color:#888;text-transform:uppercase;letter-spacing:0.08em;">Your Verification Code</p>'
      + '<p style="font-size:36px;font-weight:700;letter-spacing:0.18em;color:#000;margin:0;">' + STATE.currentOtp + '</p>'
      + '<p style="margin:8px 0 0;font-size:12px;color:#888;">Valid for 15 minutes &middot; Expires at ' + expiryTime + '</p>'
      + '</div>'
      + '<p style="color:#333;">Once verified, your exclusive launch discount will be sent to your email.</p>'
      + '<p style="color:#888;font-size:12px;">Do not share this code. If you did not spin the COOQ slot machine, ignore this email.</p>'
      + '</div>'
      + '<div style="border-top:1px solid #eaeaea;padding:16px;text-align:center;">'
      + '<p style="color:#aaa;font-size:11px;margin:0;">&copy; 2026 COOQ. All Rights Reserved.</p>'
      + '</div>'
      + '</div></body></html>';

    return brevoSend({
      to:          [{ email: email }],
      subject:     STATE.currentOtp + ' is your COOQ verification code',
      htmlContent: htmlContent
    });
  }

  /**
   * Send coupon delivery email via Brevo API
   */
  function sendCouponViaBrevo(email, prize) {
    var discountLink = 'https://cooq.com/discount/' + prize.coupon;

    var htmlContent = '<!DOCTYPE html><html><body>'
      + '<div style="font-family:system-ui,sans-serif;font-size:14px;max-width:480px;margin:0 auto;background:#fff;">'
      + '<div style="text-align:center;padding:32px 24px 24px;">'
      + '<img style="height:48px;width:auto;" src="https://cdn.shopify.com/s/files/1/0653/5446/5487/files/cooq_logo_200x60@2x.png?v=1779358221" alt="COOQ"/>'
      + '</div>'
      + '<div style="background:linear-gradient(135deg,#1a1a1a 0%,#2d2d2d 100%);padding:40px 24px;text-align:center;">'
      + '<div style="font-size:48px;margin-bottom:16px;">&#x1F3B0;</div>'
      + '<h1 style="color:#f5c842;font-size:28px;font-weight:800;margin:0 0 8px;">You Won ' + prize.discount + '% OFF!</h1>'
      + '<p style="color:rgba(255,255,255,0.75);font-size:15px;margin:0;">Your exclusive COOQ launch discount is ready.</p>'
      + '</div>'
      + '<div style="padding:32px 24px;">'
      + '<p style="color:#333;font-size:15px;margin:0 0 24px;">Hi there,</p>'
      + '<p style="color:#333;font-size:15px;margin:0 0 24px;">Congratulations! You\'ve unlocked an exclusive <strong>' + prize.discount + '% discount</strong> valid during Launch Week only.</p>'
      + '<div style="border:2px dashed #f5c842;border-radius:16px;padding:28px 24px;text-align:center;margin:0 0 24px;background:#fffdf0;">'
      + '<p style="margin:0 0 8px;font-size:11px;color:#888;text-transform:uppercase;letter-spacing:0.10em;font-weight:600;">Your Coupon Code</p>'
      + '<p style="font-size:32px;font-weight:900;letter-spacing:0.15em;color:#1a1a1a;margin:0 0 8px;font-family:Courier New,monospace;"><strong>' + prize.coupon + '</strong></p>'
      + '<p style="margin:0;font-size:12px;color:#888;">&#x23F3; Valid during Launch Week only</p>'
      + '</div>'
      + '<div style="text-align:center;margin:0 0 28px;">'
      + '<a href="' + discountLink + '" target="_blank" style="display:inline-block;background:linear-gradient(135deg,#1a1a1a 0%,#2d2d2d 100%);color:#f5c842;text-decoration:none;font-size:15px;font-weight:700;padding:16px 36px;border-radius:12px;letter-spacing:0.04em;">Claim My ' + prize.discount + '% Discount &rarr;</a>'
      + '</div>'
      + '<p style="color:#555;font-size:13px;text-align:center;margin:0 0 24px;">Clicking the button above automatically applies your discount at checkout.</p>'
      + '<div style="border-top:1px solid #eaeaea;margin:28px 0;"></div>'
      + '<p style="color:#aaa;font-size:12px;margin:0;">This discount was generated exclusively for <strong>' + email + '</strong>. Please do not share.</p>'
      + '</div>'
      + '<div style="background:#f9f9f9;border-top:1px solid #eaeaea;padding:20px 24px;text-align:center;">'
      + '<p style="color:#aaa;font-size:11px;margin:0 0 8px;">&copy; 2026 COOQ. All Rights Reserved.</p>'
      + '</div>'
      + '</div></body></html>';

    return brevoSend({
      to:          [{ email: email }],
      subject:     '\uD83C\uDF89 Your ' + prize.discount + '% OFF COOQ launch discount is here',
      htmlContent: htmlContent
    });
  }

  /**
   * Core Brevo API sender
   * @param {Object} params - { to, subject, htmlContent }
   */
  function brevoSend(params) {
    return fetch('https://api.brevo.com/v3/smtp/email', {
      method: 'POST',
      headers: {
        'Content-Type':  'application/json',
        'api-key':       CONFIG.brevo.apiKey
      },
      body: JSON.stringify({
        sender: {
          name:  CONFIG.brevo.fromName,
          email: CONFIG.brevo.fromEmail
        },
        to:          params.to,
        subject:     params.subject,
        htmlContent: params.htmlContent
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          throw new Error(err.message || 'Brevo send failed');
        });
      }
      return response.json();
    });
  }


  /* ============================================================
     13. OTP SCREEN
     ============================================================ */

  function generateOtp() {
    var otp = '';
    for (var i = 0; i < CONFIG.otp.length; i++) otp += randomInt(0, 9).toString();
    return otp;
  }

  function showOtpScreen(email) {
    if (DOM.otpEmailDisplay) DOM.otpEmailDisplay.textContent = email;
    DOM.otpInputs.forEach(function (input) {
      input.value = '';
      input.classList.remove('sm-otp-input--filled');
    });
    hideOtpError();
    showScreen(DOM.screenOtp);
    if (DOM.otpInputs[0]) DOM.otpInputs[0].focus();
    startResendTimer();
  }

  function getEnteredOtp() {
    var otp = '';
    DOM.otpInputs.forEach(function (i) { otp += i.value; });
    return otp;
  }

  function handleVerify() {
    var entered = getEnteredOtp();

    if (entered.length < CONFIG.otp.length) {
      showOtpError('Please enter all 6 digits.');
      return;
    }

    if (Date.now() > STATE.otpExpiry) {
      showOtpError('Code has expired. Please request a new one.');
      return;
    }

    if (entered !== STATE.currentOtp) {
      showOtpError('Incorrect code. Please try again.');
      shakeOtpInputs();
      DOM.otpInputs.forEach(function (i) {
        i.value = '';
        i.classList.remove('sm-otp-input--filled');
      });
      if (DOM.otpInputs[0]) DOM.otpInputs[0].focus();
      return;
    }

    hideOtpError();
    clearResendTimer();
    onOtpVerified();
  }

  function showOtpError(msg) {
    if (DOM.otpError) {
      DOM.otpError.textContent = msg;
      DOM.otpError.classList.remove('sm-screen--hidden');
    }
  }

  function hideOtpError() {
    if (DOM.otpError) {
      DOM.otpError.textContent = '';
      DOM.otpError.classList.add('sm-screen--hidden');
    }
  }

  function shakeOtpInputs() {
    if (!DOM.otpInputsWrapper) return;
    DOM.otpInputsWrapper.classList.remove('sm-otp-inputs--error');
    void DOM.otpInputsWrapper.offsetHeight;
    DOM.otpInputsWrapper.classList.add('sm-otp-inputs--error');
    setTimeout(function () {
      DOM.otpInputsWrapper.classList.remove('sm-otp-inputs--error');
    }, 500);
  }


  /* ============================================================
     14. OTP INPUT KEYBOARD NAVIGATION
     ============================================================ */

  function bindOtpInputEvents() {
    DOM.otpInputs.forEach(function (input, idx) {

      input.addEventListener('keydown', function (e) {
        var allowed = ['Backspace','Delete','Tab','ArrowLeft','ArrowRight'];
        if (allowed.indexOf(e.key) !== -1) return;
        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
      });

      input.addEventListener('input', function () {
        var val = input.value.replace(/[^0-9]/g, '');
        input.value = val ? val[val.length - 1] : '';

        if (input.value) {
          input.classList.add('sm-otp-input--filled');
          if (idx < DOM.otpInputs.length - 1) DOM.otpInputs[idx + 1].focus();
        } else {
          input.classList.remove('sm-otp-input--filled');
        }

        if (getEnteredOtp().length === CONFIG.otp.length) {
          setTimeout(handleVerify, 200);
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !input.value && idx > 0) {
          DOM.otpInputs[idx - 1].focus();
          DOM.otpInputs[idx - 1].value = '';
          DOM.otpInputs[idx - 1].classList.remove('sm-otp-input--filled');
        }
      });

      input.addEventListener('paste', function (e) {
        e.preventDefault();
        var pasted = (e.clipboardData || window.clipboardData).getData('text');
        var digits = pasted.replace(/[^0-9]/g, '').slice(0, CONFIG.otp.length);
        digits.split('').forEach(function (digit, i) {
          if (DOM.otpInputs[i]) {
            DOM.otpInputs[i].value = digit;
            DOM.otpInputs[i].classList.add('sm-otp-input--filled');
          }
        });
        var focusIdx = Math.min(digits.length, DOM.otpInputs.length - 1);
        DOM.otpInputs[focusIdx].focus();
        if (digits.length === CONFIG.otp.length) setTimeout(handleVerify, 200);
      });
    });
  }


  /* ============================================================
     15. RESEND TIMER
     ============================================================ */

  function startResendTimer() {
    clearResendTimer();
    var seconds = CONFIG.otp.resendDelay;

    if (DOM.resendTimerEl) DOM.resendTimerEl.classList.remove('sm-screen--hidden');
    if (DOM.resendBtn)     DOM.resendBtn.classList.add('sm-screen--hidden');
    if (DOM.resendCountdown) DOM.resendCountdown.textContent = seconds;

    STATE.resendTimer = setInterval(function () {
      seconds--;
      if (DOM.resendCountdown) DOM.resendCountdown.textContent = seconds;

      if (seconds <= 0) {
        clearResendTimer();
        if (DOM.resendTimerEl) DOM.resendTimerEl.classList.add('sm-screen--hidden');
        if (DOM.resendBtn)     DOM.resendBtn.classList.remove('sm-screen--hidden');
      }
    }, 1000);
  }

  function clearResendTimer() {
    if (STATE.resendTimer) {
      clearInterval(STATE.resendTimer);
      STATE.resendTimer = null;
    }
  }

  function handleResend() {
    if (!STATE.currentEmail) return;

    if (DOM.resendBtn) {
      DOM.resendBtn.textContent = 'Sending\u2026';
      DOM.resendBtn.disabled    = true;
    }

    DOM.otpInputs.forEach(function (i) {
      i.value = '';
      i.classList.remove('sm-otp-input--filled');
    });
    hideOtpError();

    sendOtpViaBrevo(STATE.currentEmail).then(function () {
      if (DOM.resendBtn) {
        DOM.resendBtn.textContent = 'Resend Code';
        DOM.resendBtn.disabled    = false;
      }
      startResendTimer();
      if (DOM.otpInputs[0]) DOM.otpInputs[0].focus();
    }).catch(function () {
      if (DOM.resendBtn) {
        DOM.resendBtn.textContent = 'Resend Code';
        DOM.resendBtn.disabled    = false;
      }
      startResendTimer();
    });
  }


  /* ============================================================
     16. ON OTP VERIFIED
     ============================================================ */

  function onOtpVerified() {
    var prize = STATE.currentPrize;
    var email = STATE.currentEmail;

    if (DOM.verifyBtn) {
      DOM.verifyBtn.disabled = true;
      DOM.verifyBtn.querySelector('.sm-btn__label').textContent = 'Verified! \u2713';
    }

    savePlayResult(prize.coupon, prize.discount, email);

    /* Fire all three saves in parallel */
    sendCouponViaBrevo(email, prize);
    saveToKlaviyo(email, prize);
    saveToShopify(email, prize);

    setTimeout(function () {
      showSuccessScreen(email);
      launchConfetti();
    }, 600);
  }


  /* ============================================================
     17. KLAVIYO
     ============================================================ */

  function saveToKlaviyo(email, prize) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  slot_machine_coupon:   prize.coupon,
                  slot_machine_discount: prize.discount + '% OFF',
                  slot_machine_date:     new Date().toISOString().slice(0, 10),
                  source:                'Slot Machine Popup'
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: CONFIG.klaviyo.listId }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CONFIG.klaviyo.publicKey, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
      body:    JSON.stringify(payload)
    }).catch(function () { /* silent fail */ });
  }


  /* ============================================================
     18. SHOPIFY CUSTOMER SAVE
     ============================================================ */

  function saveToShopify(email, prize) {
    if (!DOM.hiddenForm) return;

    var tags = [
      'Coming Soon', 'Slot Machine', 'Launch Campaign',
      'Coupon: ' + prize.coupon,
      'Discount: ' + prize.discount + '%'
    ].join(', ');

    var note = 'Slot Machine Popup'
             + ' | Coupon: ' + prize.coupon
             + ' | Discount: ' + prize.discount + '% OFF'
             + ' | Date: ' + new Date().toISOString().slice(0, 10);

    if (DOM.hiddenEmail) DOM.hiddenEmail.value = email;
    if (DOM.hiddenTags)  DOM.hiddenTags.value  = tags;
    if (DOM.hiddenNote)  DOM.hiddenNote.value  = note;

    var formData = new FormData(DOM.hiddenForm);

    fetch(DOM.hiddenForm.action, {
      method:      'POST',
      headers:     { 'X-Requested-With': 'XMLHttpRequest' },
      body:        formData,
      credentials: 'same-origin'
    }).catch(function () { /* silent fail */ });
  }


  /* ============================================================
     19. SUCCESS SCREEN
     ============================================================ */

  function showSuccessScreen(email) {
    if (DOM.successEmailDisplay) {
      DOM.successEmailDisplay.textContent = email || 'your email';
    }
    if (DOM.successDiscount) {
      DOM.successDiscount.textContent = STATE.currentPrize.discount + '% OFF';
    }
    showScreen(DOM.screenSuccess);
  }


  /* ============================================================
     20. RETURNING VISITOR SCREEN
     ============================================================ */

  function populateReturningScreen() {
    var email    = getSavedEmail();
    var discount = getSavedDiscount();

    if (DOM.returningEmailDisplay) {
      DOM.returningEmailDisplay.textContent = email || 'your email';
    }
    if (DOM.returningSubheading && discount) {
      DOM.returningSubheading.textContent =
        'You already claimed your ' + discount + '% OFF discount. '
        + 'Check your email for your coupon code.';
    }
  }


  /* ============================================================
     21. CONFETTI ENGINE
     ============================================================ */

  var CONFETTI_COLOURS = ['#f5c842','#e8935a','#4ade80','#60a5fa','#f472b6','#a78bfa','#ffffff','#fb923c'];

  function launchConfetti() {
    var canvas = DOM.confettiCanvas;
    if (!canvas) return;
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    var ctx = canvas.getContext('2d');
    stopConfetti();
    STATE.confettiParticles = [];
    for (var i = 0; i < CONFIG.confettiCount; i++) STATE.confettiParticles.push(createParticle(canvas));
    STATE.confettiAnim = requestAnimationFrame(function tick() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alive = false;
      STATE.confettiParticles.forEach(function (p) {
        updateParticle(p); drawParticle(ctx, p);
        if (p.y < canvas.height + 20) alive = true;
      });
      STATE.confettiAnim = alive ? requestAnimationFrame(tick) : null;
      if (!alive) stopConfetti();
    });
  }

  function stopConfetti() {
    if (STATE.confettiAnim) { cancelAnimationFrame(STATE.confettiAnim); STATE.confettiAnim = null; }
    if (DOM.confettiCanvas) DOM.confettiCanvas.getContext('2d').clearRect(0,0,DOM.confettiCanvas.width,DOM.confettiCanvas.height);
    STATE.confettiParticles = [];
  }

  function createParticle(canvas) {
    return {
      x: randomFloat(0,canvas.width), y: randomFloat(-canvas.height*0.3,0),
      w: randomFloat(7,14), h: randomFloat(4,9),
      colour: CONFETTI_COLOURS[randomInt(0,CONFETTI_COLOURS.length-1)],
      speedX: randomFloat(-2.5,2.5), speedY: randomFloat(3.5,7),
      rotation: randomFloat(0,Math.PI*2), rotSpeed: randomFloat(-0.12,0.12),
      opacity: 1, fade: randomFloat(0.006,0.014)
    };
  }
  function updateParticle(p) {
    p.x+=p.speedX; p.y+=p.speedY; p.rotation+=p.rotSpeed;
    p.speedY*=0.995; p.opacity-=p.fade; if(p.opacity<0) p.opacity=0;
  }
  function drawParticle(ctx,p) {
    if(p.opacity<=0) return;
    ctx.save(); ctx.globalAlpha=p.opacity; ctx.translate(p.x,p.y); ctx.rotate(p.rotation);
    ctx.fillStyle=p.colour; ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h); ctx.restore();
  }


  /* ============================================================
     22. UTILITY HELPERS
     ============================================================ */

  function randomInt(min,max)   { return Math.floor(Math.random()*(max-min+1))+min; }
  function randomFloat(min,max) { return Math.random()*(max-min)+min; }
  function isValidEmail(email)  { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

  function showInputError(inputEl, message) {
    inputEl.setAttribute('aria-invalid','true');
    var id = inputEl.id+'-error', el = document.getElementById(id);
    if (!el) {
      el = document.createElement('span');
      el.id = id; el.className = 'sm-form-errors__item';
      el.setAttribute('role','alert');
      inputEl.parentNode.appendChild(el);
      inputEl.setAttribute('aria-describedby',id);
    }
    el.textContent = message;
  }

  function clearInputError(inputEl) {
    inputEl.removeAttribute('aria-invalid');
    var el = document.getElementById(inputEl.id+'-error');
    if (el) el.textContent = '';
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var f = DOM.popup.querySelectorAll('button:not([disabled]),input');
    var first = f[0], last = f[f.length-1];
    if (e.shiftKey) { if(document.activeElement===first){e.preventDefault();last.focus();} }
    else            { if(document.activeElement===last) {e.preventDefault();first.focus();} }
  }

  function debounce(fn,wait) { var t; return function(){ clearTimeout(t); t=setTimeout(fn,wait); }; }


  /* ============================================================
     23. EVENT LISTENERS
     ============================================================ */

  function bindEvents() {
    DOM.closeBtn.addEventListener('click', hideOverlay);

    DOM.overlay.addEventListener('click', function(e) {
      if (e.target === DOM.overlay) hideOverlay();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key==='Escape' && DOM.overlay.classList.contains('sm-overlay--visible')) hideOverlay();
    });

    DOM.overlay.addEventListener('keydown', trapFocus);
    DOM.spinBtn.addEventListener('click', startSpin);

    if (DOM.customerForm) DOM.customerForm.addEventListener('submit', handleFormSubmit);
    if (DOM.skipBtn)      DOM.skipBtn.addEventListener('click', handleSkip);

    bindOtpInputEvents();

    if (DOM.verifyBtn)  DOM.verifyBtn.addEventListener('click', handleVerify);
    if (DOM.resendBtn)  DOM.resendBtn.addEventListener('click', handleResend);

    if (DOM.otpBackBtn) {
      DOM.otpBackBtn.addEventListener('click', function () {
        clearResendTimer();
        showScreen(DOM.screenEmail);
        DOM.emailInput.focus();
      });
    }

    if (DOM.successDismissBtn)  DOM.successDismissBtn.addEventListener('click', hideOverlay);
    if (DOM.returningDismissBtn) DOM.returningDismissBtn.addEventListener('click', hideOverlay);

    window.addEventListener('resize', debounce(function() {
      if (DOM.confettiCanvas) {
        DOM.confettiCanvas.width  = window.innerWidth;
        DOM.confettiCanvas.height = window.innerHeight;
      }
    }, 200));
  }


  /* ============================================================
     BOOT
     ============================================================ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());